import { cn } from "@/lib/utils";

/**
 * App-level layout shell: optional sidebar + header + main content.
 * Used as the outermost wrapper inside the <body>.
 *
 * Currently sidebar-less (Rekkd uses top nav), but the slot
 * is here for future multi-location dashboard views.
 */

interface PageShellProps {
  children: React.ReactNode;
  className?: string;
  /** Optional sidebar content */
  sidebar?: React.ReactNode;
}

function PageShell({ children, className, sidebar }: PageShellProps) {
  return (
    <div className={cn("flex min-h-screen flex-col", className)}>
      {sidebar ? (
        <div className="flex flex-1">
          <aside className="hidden lg:flex lg:w-[var(--sidebar-width)] lg:flex-col lg:border-r lg:border-[var(--color-border-default)] lg:bg-[var(--color-bg-card)]">
            {sidebar}
          </aside>
          <main className="flex-1 flex flex-col min-w-0">{children}</main>
        </div>
      ) : (
        <main className="flex-1 flex flex-col min-w-0">{children}</main>
      )}
    </div>
  );
}

export { PageShell };
export type { PageShellProps };
